import { createAsyncThunk } from '@reduxjs/toolkit'
import LogType from './log-type-model'
import { delete_logType, load_logTypes, store_logType } from './logType-service'

export const LoadLogTypesAsync = createAsyncThunk<any, any>(
  'composer/load/logType',
  async (params: { uid: string }) => {
    return await load_logTypes(params)
  },
)

export const CreateLogTypeAsync = createAsyncThunk<any, any>(
  'composer/create/logType',
  async (params: LogType) => {
    return await store_logType(params)
  },
)

export const DeleteLogTypeAsync = createAsyncThunk<any, any>(
  'composer/delete/logType',
  async (params) => {
    return await delete_logType(params)
  },
)
